import React, { useEffect } from 'react';
import { Typeahead } from 'react-bootstrap-typeahead';
import { Modal, Button, Input, Textarea, Select, Checkbox } from '../ui';
import { ASSESSMENTFORMTXT, GENERAL_FORM, SCORINGMETHODS } from '../../core/constants/common';
import { useBuilderEditor } from '../../features/builder/BuilderEditorContext';

const SectionModal = () => {
  const {
    showSectionModal, closeSectionModal, sectionname, setSectionName,
    sectiondesp, setSectionDesp, scoringmethod, setScoringMethod, weightage, setWeightage,
    actionType, selParentSection, setSelParentSection, allSections, getAllSections,
    formdata, validated, editEnable, handleCreateSectionForm, uomRequiredPopup,
    setUomRequiredPopup, multiSupportEnabled, setMultiSupportEnabled, outputUnits, uom_popup, setUomPopup,
  } = useBuilderEditor();

  useEffect(() => {
    if (showSectionModal && actionType === 2) getAllSections();
  }, [showSectionModal, actionType, getAllSections]);

  const isAssessment = formdata?.formType === ASSESSMENTFORMTXT || formdata?.formType === GENERAL_FORM;

  return (
    <Modal
      show={showSectionModal}
      onClose={closeSectionModal}
      title={editEnable ? (actionType === 1 ? 'Edit Section' : 'Edit Subsection') : (actionType === 1 ? 'Create Section' : 'Create Subsection')}
      footer={
        <>
          <Button variant="secondary" onClick={closeSectionModal}>Cancel</Button>
          <Button variant="primary" type="submit" form="section-form">Save</Button>
        </>
      }
    >
      <form id="section-form" onSubmit={handleCreateSectionForm} noValidate>
        <Input
          label={actionType === 1 ? 'Section title' : 'Subsection title'}
          value={sectionname}
          onChange={(e) => setSectionName(e.target.value)}
          required
        />
        {actionType === 2 && (
          <Select
            label="Parent section"
            value={selParentSection}
            onChange={(e) => setSelParentSection(e.target.value)}
            options={[
              { value: '', label: 'Select…' },
              ...(allSections?.sections?.map((s) => ({ value: s.id, label: s.title })) || []),
            ]}
            required
          />
        )}
        <Textarea
          label="Description"
          rows={5}
          value={sectiondesp}
          onChange={(e) => setSectionDesp(e.target.value)}
          required
        />
        {isAssessment && (
          <>
            <div className="builder-ui-modal__scoring-method">
              <div className="builder-ui-modal__scoring-method__Scoring">
                <Select
                  label="Scoring method"
                  value={scoringmethod}
                  onChange={(e) => setScoringMethod(e.target.value)}
                  options={SCORINGMETHODS.map((s) => ({ value: s.key, label: s.name }))}
                />
                {scoringmethod != "NONE" && (
                  <small >
                    Score of the section will be calculated as the{" "}
                    <span className="text-lower">{scoringmethod}</span>{" "}
                    {scoringmethod == "AVERAGE" && <span>score</span>} of all
                    the questions in this section
                  </small>
                )}
              </div>
              <div className="builder-ui-modal__scoring-method__weightage">
                <Input
                  label="Weightage (%)"
                  type="number"
                  value={weightage}
                  onChange={(e) => setWeightage(e.target.value)}
                />
                <small>
                  {`${weightage}% of the score in the form will be taken from this section`}
                </small>
              </div>
            </div>
            <Checkbox
              label="Unit of Measure"
              checked={uomRequiredPopup}
              onChange={(e) => setUomRequiredPopup(e.target.checked)}
            />
            {uomRequiredPopup && (
              <div style={{ marginTop: 8 }}>
                <Typeahead
                  id="section-uom-select"
                  className="builder-ui-modal__uom-select"
                  size="sm"
                  clearButton
                  labelKey="label"
                  options={outputUnits || []}
                  placeholder="Select UOM"
                  selected={outputUnits?.filter((u) => u.value === uom_popup) || []}
                  onChange={(selected) => setUomPopup(selected[0]?.value ?? '')}
                />
              </div>
            )}
          </>
        )}
        
      </form>
    </Modal>
  );
};

export default SectionModal;
